import Localized from "./localized";
export default Localized;
